import { Role } from '../enums';

export const Roles = [Role.ADMIN, Role.USER];
